/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  INITIATE_CREATE_CAMPAIGN: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.boilerplate.ProductAnalytics.getPageContent',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_CREATE_CAMPAIGN' },
      },
    },
    INITIATE_CREATE_CAMPAIGN: {
      invoke: {
        id: 'createCampaign',
        src: 'createCampaign',
        onDone: {
          target: 'CREATE_CAMPAIGN_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_CAMPAIGN_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    CREATE_CAMPAIGN_SUCCESS: {
      on: {
        MUTATE: { target: 'INITIATE_CREATE_CAMPAIGN' },
      },
    },
    CREATE_CAMPAIGN_ERROR: {
      on: {
        MUTATE: { target: 'INITIATE_CREATE_CAMPAIGN' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
